/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnItemsDialog extends _Ext.ItemEditorDialog<PurchaseReturnItemsRow> {
        protected getFormKey() { return PurchaseReturnItemsForm.formKey; }
        protected getLocalTextPrefix() { return PurchaseReturnItemsRow.localTextPrefix; }
        protected getDeletePermission() { return PurchaseReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return PurchaseReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return PurchaseReturnItemsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new PurchaseReturnItemsForm(this.idPrefix);

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 

        constructor() { 
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);

            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.

            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);


            this.form.Pieces.changeSelect2(e => {
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {

                    var lbr = this.form.LaborDetails.getItems();
                    var self = this;
                    lbr.forEach(function (x) {
                        x.Weight = self.form.Weight.value;
                        x.Pieces = self.form.Pieces.value;
                        x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                    });

                    this.form.LaborDetails.setItems(lbr);
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                    this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                }
            });
        }

        getItem() {
            return this.getSaveEntity();
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.ItemMaster = (this.parentEditor.parentDialog as PurchaseReturnMasterDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDiscount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.form.TransDate.valueAsDate;

            ItemFieldHelper.SalesItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
        }   
         
    }
}